import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { BsChevronLeft } from 'react-icons/bs'
import { useLocation, useNavigate } from 'react-router-dom'
import { ongoingCall } from '../../socket/services/call'
import routes from '../../routes/routes'

export function DialerOnCallPage() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [phoneNumber] = useState(state.number);
  const [timer, setTimer] = useState(state.timer);

  const [digits, setDigits] = useState('')

  const numberDialHandlerOnCall = e => {
    setDigits(digits + e.currentTarget.id)
    ongoingCall(e.currentTarget.id)
  }

  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000)
  }, [timer])

  const handleBackPage = () => {
    navigate(routes.OngoingCallPage.path, { replace: true, state: {number: phoneNumber, timer} })
  }

  return (
    <main className={styles.mainWrapper}>
      <BsChevronLeft
        className={styles.chevronLeft}
        onClick={handleBackPage}
      />
      <div className={styles.number}>{digits}</div>

      <div className={styles.dialPad}>
        <div
          className={styles.dialNumber}
          id='1'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>1</div>
        </div>

        <div
          className={styles.dialNumber}
          id='2'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>2</div>
          <div className={styles.text}>ABC</div>
        </div>

        <div
          className={styles.dialNumber}
          id='3'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>3</div>
          <div className={styles.text}>DEF</div>
        </div>

        <div
          className={styles.dialNumber}
          id='4'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>4</div>
          <div className={styles.text}>GHI</div>
        </div>

        <div
          className={styles.dialNumber}
          id='5'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>5</div>
          <div className={styles.text}>JKL</div>
        </div>

        <div
          className={styles.dialNumber}
          id='6'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>6</div>
          <div className={styles.text}>MNO</div>
        </div>

        <div
          className={styles.dialNumber}
          id='7'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>7</div>
          <div className={styles.text}>PQRS</div>
        </div>

        <div
          className={styles.dialNumber}
          id='8'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>8</div>
          <div className={styles.text}>TUV</div>
        </div>

        <div
          className={styles.dialNumber}
          id='9'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>9</div>
          <div className={styles.text}>WXYZ</div>
        </div>

        <div
          className={styles.dialNumber}
          id='*'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>*</div>
        </div>

        <div
          className={styles.dialNumber}
          id='0'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>0</div>
          <div className={styles.text}>+</div>
        </div>

        <div
          className={styles.dialNumber}
          id='#'
          onClick={numberDialHandlerOnCall}>
          <div className={styles.number}>#</div>
        </div>
      </div>
    </main>
  )
}
